// Smart search shared by every list filtered in the browser. Same rule as the
// server-side PersonSearch concern: the query is cut into words, and EVERY
// word must appear somewhere in the text, in any order, as a whole or partial
// word, ignoring case and accents. "eleve DUP" finds "DUPONT Élève Marie".

// Lower-cases, strips accents (NFD + combining marks) and collapses every
// run of blanks (non-breaking spaces included) into a single space.
export function normalizeText(value) {
  return String(value ?? "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[\s  ]+/g, " ")
    .trim();
}

// The words of a query, normalized. An empty query has no words.
export function queryWords(query) {
  const normalized = normalizeText(query);
  return normalized === "" ? [] : normalized.split(" ");
}

// True when every word of the query appears in the haystack. An empty query
// matches everything. The haystack may be a string or an array of strings
// (joined with a space, so a query can span several fields).
export function smartMatch(haystack, query) {
  const words = queryWords(query);
  if (words.length === 0) return true;

  const text = normalizeText(Array.isArray(haystack) ? haystack.join(" ") : haystack);
  return words.every((word) => text.includes(word));
}
